export async function Backbone() {
    return import(/*webpackChunkName: "~~backbone"*/ 'backbone')
}

export async function ProductConfiguratorApp() {
    return import(/*webpackChunkName: "~~product-configurator"*/ '../productConfigurator/app')
}

export async function MenuAim() {
    return import( /*webpackChunkName: "~~jquery-menu-aim"*/ '@plugins/jquery.menuaim' )
}

export async function Waypoints() {
    return import( /*webpackChunkName: "~~waypoints"*/ 'waypoints/lib/noframework.waypoints' )
}

export async function Corpus() {
    return import( /*webpackChunkName: "~~corpus"*/ '@plugins/corpus/' )
}

export async function photoGallery() {
    return import( /*webpackChunkName: "~~photo-gallery"*/ '@plugins/photo-gallery/' )
}

/* jquery plugins */
export async function jqueryAccordion() {
    return import( /*webpackChunkName: "~~jquery-accordion"*/ '@plugins/jquery.accordion' )
}

export async function jqueryColor() {
    return import( /*webpackChunkName: "~~jquery-color"*/ '@plugins/jquery.color' )
}

export async function jqueryContentToggle() {
    return import( /*webpackChunkName: "~~jquery-contenttoggle"*/ '@plugins/jquery.contenttoggle' )
}

export async function jqueryCustomFields() {
    return import( /*webpackChunkName: "~~jquery.customfields"*/ '@plugins/jquery.customfields' )
}

export async function jqueryDropDownMenu() {
    return import( /*webpackChunkName: "~~jquery-dropdownmenu"*/ '@plugins/jquery.dropdownmenu' )
}

export async function jqueryEasing() {
    return import( /*webpackChunkName: "~~jquery-easing"*/ '@plugins/jquery.easing' )
}

export async function jqueryForceNumericRange() {
    return import( /*webpackChunkName: "~~jquery.forceNumericRange"*/ '@plugins/jquery.forceNumericRange' )
}

export async function jqueryHighlight() {
    return import( /*webpackChunkName: "~~jquery-highlight"*/ '@plugins/jquery.highlight' )
}

export async function jqueryIsolatedScroll() {
    return import( /*webpackChunkName: "~~jquery.isolatedscroll"*/ '@plugins/jquery.isolatedscroll' )
}

export async function jqueryJiggle() {
    return import( /*webpackChunkName: "~~jquery-jiggle"*/ '@plugins/jquery.jiggle' )
}

export async function jqueryMakeSticky() {
    return import( /*webpackChunkName: "~~jquery-makesticky"*/ '@plugins/jquery.makesticky' )
}

export async function jqueryQuickView() {
    return import( /*webpackChunkName: "~~jquery.quickview"*/ '@plugins/jquery.quickview' )
}

export async function jqueryScrolling() {
    return import( /*webpackChunkName: "~~jquery.scrolling"*/ '@plugins/jquery.scrolling' )
}

export async function jqueryShowHint() {
    return import( /*webpackChunkName: "~~jquery.showhint"*/ '@plugins/jquery.showhint' )
}

export async function jquerySmartResize() {
    return import( /*webpackChunkName: "~~jquery-smartresize"*/ '@plugins/jquery.smartresize' )
}

export async function jquerySortElements() {
    return import( /*webpackChunkName: "~~jquery-sortelements"*/ '@plugins/jquery.sortelements' )
}

export async function jqueryTabs() {
    return import( /*webpackChunkName: "~~jquery-tabs"*/ '@plugins/jquery.tabs' )
}

export async function jqueryTogglable() {
    return import( /*webpackChunkName: "~~jquery.togglable"*/ '@plugins/jquery.togglable' )
}

export async function jqueryToggleMenu() {
    return import( /*webpackChunkName: "~~jquery-togglemenu"*/ '@plugins/jquery.togglemenu' )
}

export async function jqueryToggleRadioSelect() {
    return import( /*webpackChunkName: "~~jquery.toggleradioselect"*/ '@plugins/jquery.toggleradioselect' )
}

export async function jqueryToggleQtySelect() {
    return import( /*webpackChunkName: "~~jquery.toggleqtyselect"*/ '@plugins/jquery.toggleqtyselect' )
}

export async function jqueryTooltip() {
    return import( /*webpackChunkName: "~~jquery.tooltips"*/ '@plugins/jquery.tooltip' )
}

export async function jqueryUpiDialog() {
    return import( /*webpackChunkName: "~~jquery-upidialog"*/ '@plugins/jquery.upidialog' )
}

export async function jqueryValidate() {
    return import( /*webpackChunkName: "~~jquery-validate"*/ '@plugins/jquery.validate' )
}